module.exports = __webpack_public_path__ + "img/oceanlogo.e57273ec.svg";